<script setup lang="ts">
import GaiaIconButton from '../base/GaiaIconButton.vue';
import GaiaText from '../base/GaiaText.vue';
import { gaiaFonts, gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  page: {
    type: Number,
    required: true,
  },
  total: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits<{ prev: []; next: [] }>();

const bg = gaiaNeutral.surfaceSoft;
const border = gaiaNeutral.borderMuted;
// The mono family is the one part GaiaText has no prop for, so the readout
// passes it as a one-line :style; size and color are props.
const monoFont = gaiaFonts.mono;
</script>

<template>
  <!-- Document preview pager strip (review detail / file detail / entity
       detail panes): prev / mono "page / total" / next, #actions right
       (Download, close, …). -->
  <n-flex
    align="center"
    :size="10"
    :wrap="false"
    :style="{ padding: '10px 14px', background: bg, borderBottom: `1px solid ${border}` }"
  >
    <gaia-icon-button
      :dimension="28"
      quaternary
      aria-label="Previous page"
      :disabled="props.page <= 1"
      @click="emit('prev')"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m14 6-6 6 6 6" />
      </svg>
    </gaia-icon-button>
    <gaia-text size="control" tone="text" :style="{ fontFamily: monoFont }">
      {{ props.page }} / {{ props.total }}
    </gaia-text>
    <gaia-icon-button
      :dimension="28"
      quaternary
      aria-label="Next page"
      :disabled="props.page >= props.total"
      @click="emit('next')"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="m10 6 6 6-6 6" />
      </svg>
    </gaia-icon-button>
    <n-flex
      v-if="$slots.actions"
      inline
      align="center"
      :size="8"
      :wrap="false"
      :style="{ marginLeft: 'auto' }"
    >
      <slot name="actions" />
    </n-flex>
  </n-flex>
</template>
